// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c320f7ff","453":"49d82b08","455":"efdbb373","977":"9e5fe455"}[chunkId] + ".chunk.js";
};